import React from "react";

import delete_user from "./delete_user.png";

const DeletingUsers = () => (
  <div id="admin_user_delete" className="section">
    <h2>3.5 Delete a User</h2>
    <p>
      The ability to delete users is not always available.
      <br />
      The option is based upon individual portal settings and privileges that have been allocated to
      you as an administrator.
      <br />
      Users that have been allocated licences will also be unable to be selected for deletion.
    </p>
    <p>To delete a user:</p>
    <ol>
      <li>
        <p>
          Select <strong>Users</strong>&nbsp;&gt; <strong>List Users</strong>&nbsp; from the manage
          portal navigation menu.
        </p>
      </li>
      <li>
        <p>
          From the table of users that gets displayed, tick against those that you wish to delete.
          Those which cannot be deleted will not have a tick box against their name.&nbsp;
          <small>
            [NB. In cases where users are listed across multiple pages, navigating between them will
            reset/untick any you had selected.]
          </small>
        </p>
        <p>If you are having difficulty locating an individual user, use the search facility.</p>
        <img src={delete_user} alt="Delete Users" className="center" />
      </li>
      <li>
        <p>To delete selected users, click the Delete Selected Users button on the form.</p>
        <p>
          To proceed with the deletion, click <strong>OK</strong>&nbsp;from the confirmation box
          that appears. To cancel the deletion, click <strong>Cancel</strong>&nbsp;.
        </p>
        <p>
          If the deletion is confirmed, users will be deleted and the table of users displayed
          refreshed.
        </p>
      </li>
    </ol>
  </div>
);

export default DeletingUsers;
